import type { MapperOptions } from '#layers/core/types'
import { mapperModuleMediaCard, mapperModuleNavigationLink } from '../../modules/mappers.js'

/**
 * Page contact mapper
 * normalizes data to be used in pages
 * @param {Object} data - cms data
 * @param {Function} options - returns localized url
 * @return {Object} - normalized page data
 */
export const mapperPageContact = (data: any, options: MapperOptions) => {
  const getUrl = options.getUrl
  if (!data || !getUrl) {
    return null
  }

  return {
    pointsOfContactItems:
      data.pointsOfContactCollection?.items.map((item: any) => mapperModuleMediaCard(item, options)) || [],
    complaintLink: mapperModuleNavigationLink(data.complaintLink, getUrl),
    officesLink: mapperModuleNavigationLink(data.officesLink, getUrl),
    addressField1: data.addressField1 || null,
    addressField2: data.addressField2 || null
  }
}
